// extracted by mini-css-extract-plugin
module.exports = {"icono-wrapper":"configurations_icono-wrapper__3kNO9","icono":"configurations_icono__2jPoF"};